<template>
  <div class="m-market-aggregate">
    <div
      v-for="(list, index) in rowList"
      :key="index"
      class="m-market-aggregate-row"
    >
      <template v-for="(market) in list">
        <template v-if="market.outcomes">
          <Outcome
            v-for="outcomeId in market.outcomes.order"
            :key="outcomeId"
            class="has-desc"
            :outcome="market.outcomes.map[outcomeId]"
            :market="market"
            :event="event"
            show-desc
          />
        </template>
      </template>

      <!-- 用来占位，以保持布局自适应宽度 -->
      <div
        v-for="item in (step - list.length)"
        :key="item"
        class="m-place-outcome"
      />
    </div>
  </div>
</template>

<script>
/**
 * 7、多个 market 聚合为一行展示 presentationType === 7
 * Market中outcome数量较少（2至4个），如 exclude goals
 */

import Outcome from 'wap/match/Event/pagelet/Outcome'

export default {
  name: 'Market7Aggregate',
  components: {
    Outcome
  },
  props: {
    markets: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      step: 3
    }
  },
  computed: {
    rowList() {
      const len = this.markets.length
      const { step } = this
      const result = []
      for (let i = 0; i < len; i += step) {
        result.push(this.markets.slice(i, i + 3))
      }
      return result
    }
  }
}
</script>

<style lang="scss">
.m-market-aggregate {
  &-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .m-outcome {
    height: 36px;
    flex: 1;
    border-radius: 4px;
    margin-bottom: 4px;
    line-height: 36px;

    .desc {
      text-align: left;
    }
  }

  .m-place-outcome {
    flex: 1;
    padding: 0 10px;
  }
}
</style>
